export const s = {
  button: `w-fit-content px-8 py-3 uppercase text-clamp-lg text-white font-bold font-main bg-purple rounded-xl border border-solid border-purple curser-pointer lgx:px-6`,
}
